import { notification } from 'antd';
import { useEffect, useState } from 'react';

import apiDatalake from '../../../../services/apiDatalake';

const useTransportadoraData = ({ filters, clientes }) => {
  const [transportadoraData, setTransportadoraData] = useState([]);
  const [loadingTransportadoraData, setLoadingTransportadoraData] = useState(
    false
  );

  useEffect(() => {
    const getTransportadoraData = async () => {
      if (!clientes) {
        return;
      }

      setLoadingTransportadoraData(true);
      try {
        if (filters?.periodo !== null) {
          const { data } = await apiDatalake.post(
            'buscar-tabela-transportadores-shipper',
            {
              cpf_cnpj_cliente: clientes,
              ...(filters.periodo[0] && {
                data_inicial: filters.periodo[0].toDate(),
              }),
              ...(filters.periodo[1] && {
                data_final: filters.periodo[1].toDate(),
              }),
              ...(filters.produto &&
                filters.produto?.value !== 'Todos' && {
                  produto: filters.produto.value,
                }),
              ...(filters.cidade &&
                filters.cidade?.value !== 'Todas' && {
                  cidade: filters.cidade.value,
                }),
              ...(filters.estado &&
                filters.estado?.value !== 'Todos' && {
                  estado: filters.estado.value,
                }),
            }
          );

          if (data) {
            const transportadorasResponse = data.lista_transportadores.map(
              result => ({
                nomeTransportadora: result.nome_empresa,
                volume: result.volume,
                lote: result.quantidade_lotes,
                demanda: result.demanda,
                share: result.perc_volume_total,
                aderencia: result.aderencia_cadencia,
                quantidadeMotoristas: result.quantidade_motorista_transportador,
              })
            );

            setTransportadoraData(transportadorasResponse);
          }
        }
      } catch {
        notification.error({
          message: 'Não foi possível obter os dados da tabela',
          description: 'Tente novamente ou entre em contato com o suporte',
        });
      }
      setLoadingTransportadoraData(false);
    };
    getTransportadoraData();
  }, [
    filters.periodo,
    filters.produto,
    filters.cidade,
    filters.estado,
    clientes,
  ]);

  return {
    transportadoraData,
    loadingTransportadoraData,
  };
};

export default useTransportadoraData;
